import { styled } from '@mui/material/styles'
import Tooltip from '@mui/material/Tooltip'
import Card from '@mui/material/Card'
import React from 'react'

import { WholesalerType } from 'shared/store/useWholesalers/types'

interface Props {
   onClick: (wholesaleUuid: string) => void
   wholesaleInfo: WholesalerType
   selected: boolean
   disabled: boolean
}

export const StyledCard = styled(Card)<{ disabled: boolean; selected: boolean }>(({ theme, disabled, selected }) => ({
   display: 'flex',
   justifyContent: 'center',
   alignItems: 'center',
   width: 160,
   cursor: 'pointer',
   height: 160,
   borderRadius: 5,
   ...(selected && {
      boxShadow: `0 0 1.5em ${theme.palette.primary.main}`,
   }),
   ...(disabled && {
      filter: 'grayscale(100%)',
   }),
   backgroundColor: 'rgba(255,255,255,0.7)',
   '&:hover': {
      ...(!disabled && {
         boxShadow: `0 0 1.5em ${theme.palette.primary.main}`,
      }),
   },
}))

export default function WholesaleCard({ selected, disabled, onClick, wholesaleInfo }: Props) {
   return (
      <StyledCard disabled={disabled} selected={selected} onClick={() => onClick(wholesaleInfo.cooperationUuid)}>
         <Tooltip title={wholesaleInfo.wholesaleName}>
            <img
               height="25px"
               src={`${process.env.REACT_APP_FILES_URL}/img/logos-wholesalers/light/${wholesaleInfo.wholesaleUuid}.png`}
               alt={wholesaleInfo.wholesaleName}
            />
         </Tooltip>
      </StyledCard>
   )
}
